import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  right: 0;

  height: 50px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  
  /* justify-content: flex-end; */
  /* align-items: center; */

  visibility: hidden;

  margin-top: 0.6rem;

  padding: 0px 24px;

  .action__badge {
    background-color: var(--black-400);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 6px;

    padding: 0.5rem 0.5rem 0.5rem 1rem;

    width: auto;

    font-weight: 500;
    font-size: 0.8125rem;
    font-family: DM Sans, sans-serif;

    display: flex;
    flex-direction: row;
    align-items: center;

    cursor: pointer;
    
    svg {
      width: 20px;
      height: 20px;
    }

    &.unique {
      background-color: var(--white);
      color: var(--black-200);

      padding: 0.5rem 1rem;

      &:hover {
        opacity: 0.9;
        background-color: var(--white);
      }
    }

    &:hover {
      background-color: var(--black-200);
    }
  }
`;

export const Menu = styled.div`
  border: 2px solid var(--dividers);

  /* padding: 0.5rem 0rem; */

  background-color: var(--black-200);

  min-width: 170px;

  margin-top: 0.5rem;

  border-radius: 4px;

  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);

  z-index: 999;
`;

export const MenuItem = styled.div`
  cursor: pointer;

  border-left: 2px solid transparent;

  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0.7rem;
  
  span {
    font-family: Inter, sans-serif;
    font-size: 0.9rem;
  
    color: var(--white);
    opacity: 0.7;
  }

  &:hover {
    border-left-color: var(--primary);
    
    span {
      opacity: 1;
    }
  }
`;

export const MenuItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding-right: 0.5rem;

  svg {
    width: 16px;
    height: 16px;

    path {
      stroke: #02191D;
    }
  }
`;